import { useToastState, Toast } from "@tamagui/toast";

export const CurrentToast = () => {
  const currentToast = useToastState();

  if (!currentToast || currentToast.isHandledNatively) {
    return null;
  }

  return (
    <Toast
      animation="200ms"
      key={currentToast.id}
      duration={currentToast.duration}
      enterStyle={{ opacity: 0, transform: [{ translateY: 100 }] }}
      exitStyle={{ opacity: 0, transform: [{ translateY: 100 }] }}
      transform={[{ translateY: 0 }]}
      opacity={1}
      scale={1}
      viewportName={currentToast.viewportName}
      minWidth={500}
      $xs={{ minWidth: 0, maxWidth: "100%" }}
      backgroundColor="$gray1"
      flexDirection="row"
      gap="$2"
      alignItems="center"
      padding="$3"
      borderWidth={2}
      borderColor="$transparentBorder"
      borderRadius="$6"
    >
      {currentToast.icon}

      <Toast.Title fontSize="$3" fontWeight="bold" lineHeight="$1">
        {currentToast.title}
      </Toast.Title>
    </Toast>
  );
};
